export default __webpack_public_path__ + "static/media/usaFlag.8397404f.png";